export const getDefaultSortOrder = (key: string, searchParams?: URLSearchParams) => {
	if (!searchParams) {
		searchParams = new URLSearchParams(window.location.search);
	}

	return !searchParams.get('ordering')
		? undefined
		: searchParams.get('ordering') === '-' + key
			? 'descend'
			: searchParams.get('ordering') === key
				? 'ascend'
				: undefined;
};
